var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 28 28",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3a3a3a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m309.38 102.837h16.768a1.1 1.1 0 0 0 1.1-1.1v-16.742a1.1 1.1 0 0 0 -1.1-1.1h-16.571a1.1 1.1 0 0 0 -1.1 1.086l-.2 16.743a1.1 1.1 0 0 0 1.103 1.113z",
    transform: "translate(-307.281 -75.837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.244 42.475.065-5.5a1.1 1.1 0 0 1 1.1-1.086h16.571a1.1 1.1 0 0 1 1.1 1.1v16.744a1.1 1.1 0 0 1 -1.1 1.1h-5.485",
    transform: "translate(-349.078 -34.891)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d8685ca182700181b1faf8af4eeae539.svg";
export { ForwardRef as ReactComponent };